module.exports = __webpack_public_path__ + "img/icon_bayer.72f31850.png";